export const iconFontAwesomeChartsDiagramsSquarePollHorizontal = (
	<i className="fa-solid fa-square-poll-horizontal"></i>
);
